var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7703_49021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6H1.33333V8C3 9.33333 3 10.4873 3 12.3147V14.3333C3 14.687 2.85952 15.0261 2.60948 15.2761C2.35943 15.5262 2.02029 15.6667 1.66667 15.6667H0M16 6H14.6667V8C13 9.33333 13 10.4873 13 12.3147V14.3333C13 14.687 13.1405 15.0261 13.3905 15.2761C13.6406 15.5262 13.9797 15.6667 14.3333 15.6667H16M5 12.3147V14.3333C5 14.687 5.14048 15.0261 5.39052 15.2761C5.64057 15.5262 5.97971 15.6667 6.33333 15.6667H9.66667C10.0203 15.6667 10.3594 15.5262 10.6095 15.2761C10.8595 15.0261 11 14.687 11 14.3333V12.3147C11 10.488 11 9.33333 9.33333 8V6H6.66667V8C5 9.33333 5 10.4873 5 12.3147ZM9.33333 2.964C9.33333 3.71067 8.73667 4.33333 8 4.33333C7.26333 4.33333 6.66667 3.71067 6.66667 2.964C6.66756 2.89111 6.67822 2.81644 6.69867 2.74C6.82533 2.25267 7.16333 1.856 7.476 1.46667L7.556 1.368C7.99533 0.746 8 0.228 8 0C8 0.228 8.00467 0.746667 8.44467 1.368L8.52467 1.46667C8.83667 1.856 9.17467 2.25267 9.30133 2.74C9.32222 2.81644 9.33289 2.89111 9.33333 2.964Z",
    stroke: "#4B5563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7703_49021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefill);
export default __webpack_public_path__ + "static/media/Refill.31122716d22c125a42099c7d5403a943.svg";
export { ForwardRef as ReactComponent };